import React from 'react';

const GuestHome = () => {
    return (
        <div className="guest-home">
            <h1>Welcome to Project MELD!</h1>
            <p>Please log in or sign up to access the full features of our application.</p>

        </div>
    );
};

export default GuestHome;